import React, {useState, useEffect} from 'react'

const AdminEnquiry = () => {

    const [enquiry, setEnquiry] = useState([]);

    // Fetch sites data from the backend when the component is mounted
    useEffect(() => {
        const fetchEnquiry = async () => {
            try {
                const response = await fetch('https://api.dectwincam.com/api/contact-submission');
                const data = await response.json();

                if (response.ok) {
                    setEnquiry(data); // Store the fetched sites in state
                } else {
                    console.error('Failed to fetch sites:', data);
                }
            } catch (error) {
                console.error('Error while fetching sites:', error);
            }
        };

        fetchEnquiry();
    }, []); // Empty dependency array means it runs once when the component mounts


    return (
        <>
            <section className='py-5 bg-light'>
                <div className='container'>

                    <div className="d-flex justify-content-center">
                        <hr className="shop-hr" />
                        <h4 className="px-3 text-center text-nowrap">Form Enquiry Submissions</h4>
                        <hr className="shop-hr" />
                    </div>

                    <div className='table-responsive mt-4'>
                        <table className='w-100'>

                            <tr className='bg-white'>
                                <th className='px-3 py-2'>S No</th>
                                <th className='px-3 py-2'>Name</th>
                                <th className='px-3 py-2'>Email</th>
                                <th className='px-3 py-2'>Subject</th>
                                <th className='px-3 py-2'>Mobile</th>
                                <th className='px-3 py-2'>Message</th>
                            </tr>


                            {enquiry.length > 0 ? (
                                enquiry.map((enquire, index) => (
                                    <tr key={enquire.id}>
                                        <td className='px-3 py-2'>{index+1}</td>
                                        <td className='px-3 py-2'>{enquire.name}</td>
                                        <td className='px-3 py-2'>{enquire.email}</td>
                                        <td className='px-3 py-2'>{enquire.subject}</td>
                                        <td className='px-3 py-2'>{enquire.mobile}</td>
                                        <td className='px-3 py-2'>{enquire.message}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr className='text-center'><td colspan="6" className='py-2 px-3'>No Enquiry available.</td></tr>
                            )}

                        </table>
                    </div>
                    {/* table ends */}


                </div>
            </section>
        </>
    )
}

export default AdminEnquiry
